"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveExtendedTag = void 0;
const http_1 = require("../../utils/http");
const endpoint = 'tags';
/**
 * Retrieve tag with extended information from Bee node
 *
 * @param requestOptions Options for making requests
 * @param uid UID of tag to be retrieved
 */
async function retrieveExtendedTag(requestOptions, uid) {
    const response = await (0, http_1.http)(requestOptions, {
        url: `${endpoint}/${uid}`,
        responseType: 'json',
    });
    return response.data;
}
exports.retrieveExtendedTag = retrieveExtendedTag;
